import { render, staticRenderFns } from "./return-card.vue?vue&type=template&id=7604936d&scoped=true&"
import script from "./return-card.vue?vue&type=script&lang=ts&"
export * from "./return-card.vue?vue&type=script&lang=ts&"
import style0 from "./return-card.vue?vue&type=style&index=0&id=7604936d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7604936d",
  null
  
)

export default component.exports